import React, { Component } from "react";
import { Link } from "react-router-dom";
import OrderStatusBadge from "../../Shared/OrderStatusBadge";
import { formatDateTime, formatAmount } from "src/Common/utils";

const Menu = ({ id }) => (
  <div className="dropdown">
    <a
      className="btn btn-sm btn-icon-only text-light"
      href="javascript:void(0)" /* eslint-disable-line no-script-url */
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i className="fas fa-ellipsis-v" />
    </a>
    <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
      <Link className="dropdown-item" to={`/vendas/${id}`}>
        Detalhes
      </Link>
      {/* <a className="dropdown-item" href="#">Cancelar</a> */}
    </div>
  </div>
);

const NotAvailableAmount = () => <small>Não Disponível</small>;

export default class TableRow extends Component {
  render() {
    const { id, createdAt, updatedAt, order, licensePlate, renavam } = this.props;
    const establishment = this.props.establishment || {};
    const {
      protocol,
      baseAmount,
      totalAmount,
      orderStatus,
      externalOrderNumber,
    } = order;
    return (
      <tr>
        <th scope="row">
          <Link to={`/vendas/${id}`}>{protocol}</Link>
        </th>
        {externalOrderNumber && <th>{externalOrderNumber}</th>}
        {!externalOrderNumber && <th>{licensePlate}</th>}
        {!externalOrderNumber && <th>{renavam}</th>}
        <td>
          {baseAmount ? formatAmount(baseAmount) : <NotAvailableAmount />}
        </td>
        <td>
          {totalAmount ? formatAmount(totalAmount) : <NotAvailableAmount />}
        </td>
        <td>
          {this.props.baseAmount ? (
            formatAmount(this.props.baseAmount)
          ) : (
            <NotAvailableAmount />
          )}
        </td>
        <td>
          {totalAmount && baseAmount ? (
            formatAmount(totalAmount - baseAmount)
          ) : (
            <NotAvailableAmount />
          )}
        </td>
        <td>{establishment.title}</td>
        <td>
          <OrderStatusBadge status={orderStatus} />
        </td>
        <td>{formatDateTime(createdAt)}</td>
        <td>{formatDateTime(updatedAt)}</td>
        <td className="text-right">
          <Menu id={id} />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/TableRow.js